import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useRequests } from '../requests/useRequests'
import CssBaseline from '@mui/material/CssBaseline'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { backgroundStyle } from '../styles/background'

interface UsernameProps {
  username: string | null
  setUsername: (s: string) => void
  setIsUsernameCorrect: (b: boolean) => void
}

const Username = ({
  username,
  setUsername,
  setIsUsernameCorrect
}: UsernameProps): JSX.Element => {
  const requestMaker = useRequests()
  const [usernameError, setUsernameError] = useState<string | null>(null)

  const handleChangeUsername = async (username: string): Promise<void> => {
    setUsername(username)
    if (username === '') {
      return
    }
    const response = await requestMaker.emailOrUsernameExists(username)

    if (response.data) {
      setUsernameError(null)
    } else {
      setUsernameError('User with this username does not exist')
    }
  }

  const handleUsernameSubmit = async (): Promise<void> => {
    if (usernameError !== null) {
      return
    }
    try {
      await requestMaker.sendForgotPasswordCode(username!)
      setIsUsernameCorrect(true)
    } catch (e) {
      setUsernameError('User has unconfirmed email')
    }
  }

  return (
    <>
      <form
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault()
            void handleUsernameSubmit()
          }
        }}
      >
        <Container component='main' maxWidth='xs'>
          <div style={backgroundStyle} />
          <CssBaseline />
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
          >
            <Typography component='h6' variant='h6'>
              Type username or email of user to receive code on email address.
            </Typography>
            <TextField
              error={usernameError !== null}
              variant='filled'
              helperText={usernameError}
              value={username}
              onChange={e => {
                void handleChangeUsername(e.target.value)
              }}
              margin='normal'
              required
              fullWidth
              id='username'
              label='Username or Email'
              name='username'
              autoComplete='username'
              autoFocus
            />
            <Button
              type='submit'
              fullWidth
              variant='contained'
              sx={{ mt: 3, mb: 2 }}
              disabled={
                username === null ||
                username?.length === 0 ||
                usernameError !== null
              }
              onClick={e => {
                e.preventDefault()
                void handleUsernameSubmit()
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  void handleUsernameSubmit()
                }
              }}
              tabIndex={0}
            >
              Submit
            </Button>
          </Box>
        </Container>
      </form>
    </>
  )
}

export default Username
